import { Component, ElementRef, OnInit, forwardRef, ChangeDetectionStrategy, input, viewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import * as _ from 'lodash-es';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { AsyncPipe } from '@angular/common';



@Component({
    selector: 'app-chips-list-object',
    templateUrl: './chips-list-object.component.html',
    styleUrls: ['./chips-list-object.component.scss'],
    providers: [
    // {
    //   provide: NG_VALUE_ACCESSOR,
    //   useExisting: forwardRef(() => ChipsListObjectComponent),
    //   multi: true
    // }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatFormField, MatLabel, MatChipGrid, MatChipRow, MatChipRemove, MatIcon, MatChipInput, FormsModule, MatAutocompleteTrigger, ReactiveFormsModule, RxReactiveFormsModule, MatAutocomplete, MatOption, AsyncPipe]
})
export class ChipsListObjectComponent implements OnInit {

  readonly allOptions = input<any[]>([]);
  readonly placeholder = input('Rechercher');
  readonly label = input('');
  readonly labelKey = input<string | string[]>('fullname');
  readonly valueKey = input<string>();
  readonly appearance = input<'fill' | 'outline'>('fill');

  // Liste interne des IDs sélectionnés

  readonly control = input<FormControl>(new FormControl([]));
  
  get selectedItems(): string[] {
      return this.control().value;
  };
  set selectedItems(value: string[]) {
    this.control().setValue(value);
  }

  searchControl = new FormControl('');

  filteredItems$!: Observable<any[]>;
  readonly autoTrigger = viewChild.required(MatAutocompleteTrigger);
  readonly chipInput = viewChild<ElementRef>('autoCompleteChipInput');

  // Méthodes fournies par ControlValueAccessor :
  // private onChange: (value: string[]) => void = () => { };
  // private onTouched: () => void = () => { };

  constructor() { }



  ngOnInit(): void {

    this.filteredItems$ = this.searchControl.valueChanges.pipe(
      // Au démarrage, on émet la chaîne vide (type string)
      startWith(''),

      // S'il arrive un null, on le remplace par ''
      map(value => value || ''),

      // Ici on est sûr que value est un string
      map(value => {
        const filterValue = value.toLowerCase();
        return this.allOptions()
          .filter(u => !this.selectedItems.includes(u._id))
          .filter(u => u.fullname.toLowerCase().includes(filterValue));
      })
    );
  }



  // /**
  //  * CONTROL VALUE ACCESSOR - writeValue
  //  * => Quand le parent appelle setValue ou patchValue sur le formControl,
  //  *    Angular invoque writeValue pour mettre à jour l’état interne.
  //  */
  // writeValue(value: string[]): void {
  //   // if (value) {
  //   //   this.selectedItems = [...value];
  //   // } else {
  //   //   this.selectedItems = [];
  //   // }
  // }

  // /**
  //  * CONTROL VALUE ACCESSOR - registerOnChange
  //  * => On récupère le callback à appeler quand la valeur du champ change
  //  */
  // registerOnChange(fn: (value: string[]) => void): void {
  //   this.onChange = fn;
  // }

  // /**
  //  * CONTROL VALUE ACCESSOR - registerOnTouched
  //  * => On récupère le callback à appeler quand le champ est «touché»
  //  */
  // registerOnTouched(fn: () => void): void {
  //   this.onTouched = fn;
  // }

  /**
   * Ajout d’un utilisateur sélectionné depuis l’autocomplete
   */
  selectOption(itemSeleted: string): void {
    if (!this.selectedItems.find(item => _.isEqual(itemSeleted, item))) {
      console.log('id', itemSeleted);
      console.log('Valeur avant ajout =', this.selectedItems);
      // this.selectedItems.push(id);

      this.selectedItems = [...this.selectedItems, itemSeleted];
      // On notifie Angular que la valeur a changé
      // this.onChange(this.selectedItems);
      console.log('Valeur après ajout =', this.selectedItems);

    }
    this.resetInput();
    console.log('Valeur après reset =', this.searchControl.value);
    // Champ « touché »
    // this.onTouched();

  }

  /**
   * Suppression d’un utilisateur
   */
  removeOption(itemSeleted: string): void {
    this.selectedItems = this.selectedItems.filter(item => item !== itemSeleted);
  }

  /**
   * Retourne la liste d’utilisateurs filtrés qui ne sont pas encore sélectionnés
   */
  filteredUsers() {
    return this.allOptions().filter(u => !this.selectedItems.includes(u._id));
  }


  getItem(value: any) {
    if (this.valueKey()) {
      return this.allOptions().find((u:any) => this.getValue(u) === value);    
    }
    return value;
  }

  /**
   * Permet de récupérer un objet User par ID
   */
  getLabel(input: any | string): string {
    let item = this.getItem(input);
    return this.getObjectLabel(item);
  }

  getObjectLabel(item: any) {
    const labelKey = this.labelKey();
    if (item && _.isString(labelKey)) return item[labelKey];
    if (item && _.isArray(labelKey)) {
      const key = labelKey.find(key => !!item[key]);
      return key? item[key] : '';
    }    
    return '';
  }

  getValue(item: any) {
    const valueKey = this.valueKey();
    if (valueKey) {
      return item[valueKey];
    }
    return item;
  }

  /**
   * Gère le focus de l’input (optionnel, pour actualiser la liste, etc.)
   */
  focusInput(): void {
    if (!this.searchControl.value) {
      this.resetInput();
    } else {
      this.searchControl.setValue(this.searchControl.value);
    }
  }

  private resetInput(): void {
    this.chipInput()!.nativeElement.value = '';
    this.searchControl.reset();
  }
}
